import { message } from 'antd';

import * as constants from './constants';
import common from '../../common';


//#region ReleaseNotes

export function loadReleaseNotes(lang) {
    return async (dispatch, getState) => {
        return await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ReleaseNotes/${lang}`);
    };
}

export function saveReleaseNote(lang, values) {
    return async (dispatch, getState) => {
        await common.apiClient.put(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ReleaseNotes/${lang}`, values);
        message.success("Saved");
    };
}
export function deleteReleaseNote(id) {
    return async (dispatch, getState) => {
        await common.apiClient.delete(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/ReleaseNotes/${id}`);
        message.success("Item deleted");
    };
}

//#endregion